import Case from './Case'

export default class DraftCase extends Case {}
